import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';
import { EventColorEnum, ParentSignupInputItem, PaymentSourceInputItem, SignupPaymentType, WebsiteBlockSignupFormDisplayItem } from '@sb/library/data-models';
import { StyleManager } from '@sb/library/managers';
import { StepperComponent } from '@sb/library/stepper';
import { SignupSteps, StudentSignupFrontendInputItem } from '../signup-form.definitions';

@Component({
    selector: 'lib-signup-form-design-block-confirmation',
    templateUrl: './signup-form-design-block-confirmation.component.html',
    styleUrl: './signup-form-design-block-confirmation.component.scss'
})
export class SignupFormDesignBlockConfirmationComponent extends BaseViewComponent {

    @Input({required: true}) student!: StudentSignupFrontendInputItem;
    @Input({required: true}) paymentSource!: PaymentSourceInputItem | null;
    @Input({required: true}) data!: WebsiteBlockSignupFormDisplayItem;
    @Input() stepper!: StepperComponent<typeof SignupSteps>;
    @Input() isBookingWidget: boolean = false;
    @Input() parent!: ParentSignupInputItem;

    @Output() submitClicked: EventEmitter<void> = new EventEmitter();
    @Output() previousClicked: EventEmitter<void> = new EventEmitter();

    private _submitButtonClicked: boolean = false;

    constructor(private _StyleManager: StyleManager) {
        super();
    }

    SubmitClicked(): void {
        this._submitButtonClicked = true;
        this.submitClicked.emit();
    }

    PreviousClicked(): void {
        this._submitButtonClicked = false;
        this.previousClicked.emit();
    }

    EnableSubmitButton(): void {
        this._submitButtonClicked = false;
    }

    GetInitial(name: string): string {
        return name.substring(0, 1);
    }

    BackgroundColorClass(color: EventColorEnum): string {
        return this._StyleManager.GetBackgroundColorCssClass(color);
    }

    get SignupPaymentType(): typeof SignupPaymentType {
        return SignupPaymentType;
    }

    get submitButtonClicked(): boolean {
        return this._submitButtonClicked;
    }

    get currentStepIndex(): number {
        return this.stepper.currentStepPosition + 1;
    }

    get totalStepCounts(): number {
        return this.stepper.totalSteps - 1;
    }
}
